import React from 'react';
import "./index.css"
import classnames from 'classnames';
import assets from "../../../../../util/assets";
import PropTypes from "prop-types";
import {PricingType} from "../../../broadcaster/library/pricing/type";
import ProgressiveImage from "react-progressive-image";
import VideoPlayerModal from "../../../../modal/clipstore/broadcaster/VideoPlayerModal/VideoPlayerModal";
import {getAgeGroupDiv} from "../../../../../util/utility";

MoreVideo.propTypes = {
    index: PropTypes.number,
    horizontal: PropTypes.bool,
    playing: PropTypes.bool,
    content: PropTypes.object.isRequired,
    openDetail: PropTypes.func.isRequired,
};

MoreVideo.defaultProps = {
    horizontal:false,
    playing:false,
    index:0,
}
function MoreVideo(props) {

    const container = classnames({
        "display-flex-flex-direction-row" : !props.horizontal,
        "display-flex-flex-direction-bottom" : props.horizontal,
        "border-selection":props.hasOwnProperty("border") && props.hasOwnProperty("selectedIndex") && props.selectedIndex === props.index,
        "gradient-border":props.hasOwnProperty("border")
    })
    return (
        <div className={container}>

            <ProgressiveImage
                delay={1000}
                src={props.content.thumbnail_url}
                placeholder="placeholder"
            >
                {(src, loading) => {
                    return loading ? (
                            <img alt="home container thumbnail"
                                 className="display-flex-flex-direction-img"
                                 src={assets.clipstore.placeholder}/>
                        ) :
                        (
                            <div className={"display-flex-flex-direction-img"}
                                 onClick={() => {
                                     props.openDetail(props.content,props.index)
                                 }}
                                 style={{backgroundImage: "url('" + props.content.thumbnail_url + "')"}}>


                                <PricingType
                                    content={props.content}
                                    pricingStatus={props.content.pricing_type}/>

                                {
                                    (props.content.type === "live" || props.content.type === "available") &&
                                    <div className="home-container-list-item-header">
                                        <div className="live-or-available-rectangle">
                                            {
                                                props.content.type === "live"
                                                    ?
                                                    <span
                                                        className="live-or-available-text live-bg">{props.content.type}</span>
                                                    :
                                                    <span
                                                        className="live-or-available-text available-bg">{props.content.type}</span>
                                            }
                                        </div>
                                    </div>
                                }

                                {
                                    props.content.type === "video"
                                        ?
                                        <div className="home-container-list-video-time-container">
                                            <div
                                                className="home-container-list-video-time-text">{props.content.duration_formatted}</div>
                                        </div>
                                        :
                                        (
                                            props.content.type === "gallery" &&
                                            <div
                                                className="home-container-list-gallery-time-container">
                                                <img src={assets.clipstore.gallery_videos}
                                                     alt="gallery videos" height={16}/>
                                                <span
                                                    className="home-container-list-gallery-time-text">{props.content.total_videos}</span>
                                            </div>
                                        )
                                }
                                <div className="home-container-list-video-time-container"
                                     style={{backgroundColor: 'transparent'}}>
                                    {getAgeGroupDiv(props.content.age_group, "age-group-24")}
                                </div>


                            </div>
                        )

                }}
            </ProgressiveImage>

            <div className="display-flex-flex-direction-column">
                <div className="mode-videos-title">
                    {props.content.title}
                </div>
                <div>
                    <span className="mode-videos-views">{`${props.content.views} views`}</span>
                    {props.playing && <span className="mode-videos-playing"> Playing...</span>}
                </div>

            </div>
        </div>
    );
}

export default MoreVideo;